import { AnnotationStatus } from '@rossum/api-client/shared';

const unResetableStatuses: Array<AnnotationStatus> = [
  'exporting',
  'exported',
  'deleted',
  'failed_export',
];

export const canResetOnMove = <T extends Array<{ status: AnnotationStatus }>>(
  annotations: T
) => !annotations.find(({ status }) => unResetableStatuses.includes(status));
